import React, { CSSProperties, SyntheticEvent } from 'react'
import { connect } from 'react-redux'
import { Dropdown, Input } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { LKDate } from 'loankeeper-common/helpers/Date'
///@ts-ignore
import LKButton from 'shared/LKButton'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
///@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { withUserConfig, colors } from 'shared'
///@ts-ignore
import { DataSegment } from 'shared/Helpers'
///@ts-ignore
import LKPrintButton, { constants as LKPrintButtonConstants } from 'shared/LKPrintButton'
///@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'

import { loadProductDetailsIfNeeded } from '../../../../store/product'
import { collateralView, collateralVisa, collateralUndoVisa } from '../../../../store/collateral'
import { actions as DetailsContainerActions, constants as DCConstants } from '../../../DetailsContainer'
import translate, { translateLKMessage } from '../../translator'

import BlockLoanButton from './BlockLoanButton'
import UndoLoanBlockButton from './UndoLoanBlockButton'
import VisaLoanButton from './VisaLoanButton'
import UndoVisaLoanButton from './UndoVisaLoanButton'
import BindCollateralModal, { open as openCollateralModal } from './BindCollateralModal'
import UnlinkCollateralModal, { open as openUnlinkCollateralModal } from './UnlinkCollateralModal'

import CollateralForm, { open as openCollateralForm } from '../../../CollateralForm'

import LKPrintGrid from '../../../shared/LKPrintGrid'

import { CollateralData, CollateralProps, CollateralState, ContextMenuParamsProps } from '../../types.LoanDetails'
import { AppDispatch } from 'src/store/index.d'
import { linkCollateral } from 'src/store/loan'
import { LinkCollateralParams } from '@lk/api'

const LKPrintGridContainer = styled.div`
  flex: 4;
  display: flex;
`

function renderPriceRate(CollateralPrice: number, OSBalance: number) {
  if (OSBalance === 0) {
    return ''
  }

  const label = `${CollateralPrice} / ${OSBalance}`
  const result = `${(+(CollateralPrice / OSBalance).toFixed(4) * 100).toFixed(2)}`

  return `${label} = ${result} %`
}

const LKGridConfig = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_collateral_joined',
  },

  syncGridState: true,
  enableColumnsOrder: true,
  enableColumnsResize: true,
  enableColumnsHide: true,
  enableSorting: true,
  enableRowSelection: true,

  getRowStyle: ({ node: { data } }): CSSProperties => {
    if (data.Met === 0) {
      return { color: colors.red, backgroundColor: '#f5fffa' }
    }

    if (data.GlobalTypeID === 4 || data.GlobalTypeID === 5 || data.GlobalTypeID === 6) {
      return { backgroundColor: colors.grey }
    }

    if (data.FrameChild === 1) {
      return { color: colors.green, backgroundColor: '#E5FFE5' }
    }

    if (data.TypeID === 7) {
      return { color: 'white', backgroundColor: colors.green }
    } else {
      return { color: 'black' }
    }
  },

  getRowNodeId: (row) => row?.ID,

  columnConfigs: {
    LiquidPrice: {
      valueFormatter: ({ value }: { value: number }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    MarketPrice: {
      valueFormatter: ({ value }: { value: number }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    IsExpired: {
      iconComponent: (value: number) => (value === 1 ? 'clock' : null),
    },

    IsInsured: {
      iconComponent: (value: number) => (value === 1 ? { alias: 'life_ring', background: true } : null),
    },
  },
}

const COLLATERAL_ADD = 'CollateralAddFormInLoanCollaterals'
const COLLATERAL_EDIT = 'CollateralEditFormInLoanCollaterals'

@withRouter
@withConstantPermissions()
@withUserConfig(['Print_After_Coll_Add', 'ID as AuthenticatedUserID'])
///@ts-ignore
@connect(undefined, {
  openCollateralDetails: () => LKModalActions.open({ name: 'FrameCollateralDetails' }),

  openErrorModal: (message: string) => LKModalActions.openError(message),
  openBindCollateralModal: (ID: string, hash: string) => openCollateralModal(ID, hash),
  openUnlinkModal: (ID: string, hash: string, CollateralID: number, CollateralHash: string) =>
    openUnlinkCollateralModal(ID, hash, CollateralID, CollateralHash),
  reloadCollaterals: (ID: string, hash: string) =>
    DetailsContainerActions.fetchPage({
      type: 'Loan',
      ID,
      hash,
      page: 'collaterals',
    }),
  openCollateralAddForm: (clientId: number, clientHash: string) =>
    openCollateralForm({ name: COLLATERAL_ADD, clientId, clientHash }),
  openCollateralEditForm: (ID: number, hash: string) => openCollateralForm({ name: COLLATERAL_EDIT, ID, hash }),
  loadProductDetailsIfNeeded,

  collateralView,
  collateralVisa,
  collateralUndoVisa,
})
//@ts-ignore
@connect(undefined, (dispatch: AppDispatch) => ({
  linkCollateral: (params: Omit<LinkCollateralParams, 'page'>) => dispatch(linkCollateral(params)),
}))
class Collaterals extends React.Component<CollateralProps, CollateralState> {
  state = {
    searchOptions: [
      { key: 1, value: 'AgreementNo', text: translate('dbgrd_collateral_joined.AgreementNo') },
      { key: 2, value: 'FullName', text: translate('dbgrd_collateral_joined.FullName') },
      { key: 3, value: 'GlobalType', text: translate('dbgrd_collateral_joined.GlobalType') },
      { key: 4, value: 'Location', text: translate('dbgrd_collateral_joined.Location') },
      { key: 5, value: 'Comment', text: translate('dbgrd_collateral_joined.Comment') },
      { key: 6, value: 'Description', text: translate('dbgrd_collateral_joined.Description') },
    ],
    searchOption: 'AgreementNo',
    filtered: null,

    canDetachCollateral: false,
    canAttachCollateral: !!this.props.permissions.LOAN_ATTACH_COLL,

    canEditCollateral: false,
  }
  menuX: number
  menuY: number
  menuLoading: boolean
  currentPageX: number
  currentPageY: number

  componentDidMount() {
    this.checkAttachEditPermissions()
  }

  redirectToCollateralDetails = ({ ID, HashSum_CollateralID_, TypeID }: CollateralData) => {
    this.props.history.push(`/secure/collateral/${ID}/details/${HashSum_CollateralID_}/${TypeID}`)
  }

  onRowDoubleClicked = ({ node: { data } }: { node: { data: CollateralData } }) => {
    if (this.props.permissions.VIEW_COLLATERAL) {
      this.redirectToCollateralDetails(data)
    }
  }

  getContextMenuItems = (params: ContextMenuParamsProps) => {
    const {
      node: { data },
    } = params

    if (!this.menuLoading) {
      this.menuX = this.currentPageX
      this.menuY = this.currentPageY
    }

    const items = [
      ...(this.props.data.base.IsArrested !== 1 && this.state.canEditCollateral
        ? [
            {
              name: translate('cmd_edit_collateral'),
              icon: 'edit',
              action: () => this.props.openCollateralEditForm(data.ID, data.HashSum_CollateralID_),
              permissionKey: 'EDIT_COLLATERAL',
            },
          ]
        : []),

      ...(this.props.permissions.VIEW_COLLATERAL
        ? [
            {
              name: translate('cmd_view_collateral'),
              icon: 'info',
              action: () => this.redirectToCollateralDetails(data),
            },
          ]
        : []),
      ...(data.Visa !== 1
        ? [
            {
              name: translate('cmd_visa_collateral'),
              action: () =>
                this.props
                  .collateralVisa({ CollateralID: data.ID, HashSum_CollateralID_: data.HashSum_CollateralID_ })
                  .then(this.handleReloadGrid),
              icon: 'visa_collateral',
              type: 'visa_operations',
              permissionKey: 'COLLATERAL_VISA',
              confirmModalConfig: { message: translateLKMessage('MSG_ARE_YOU_SURE') },
            },
          ]
        : []),
      ...(data.Visa === 1
        ? [
            {
              name: translate('cmd_delete_collateral_visa'),
              icon: 'bullet_green_delete',
              type: 'visa_operations',
              action: () =>
                this.props
                  .collateralUndoVisa({ CollateralID: data.ID, HashSum_CollateralID_: data.HashSum_CollateralID_ })
                  .then(this.handleReloadGrid),
              permissionKey: 'COLLATERAL_VISA',
              confirmModalConfig: { message: translateLKMessage('MSG_ARE_YOU_SURE') },
            },
          ]
        : []),
      ...(this.props.permissions.PRINT_COLL_AGREEMENT &&
      (this.props.permissions.COLL_PRINT_WITHOUT_VISA || data.Visa !== 0)
        ? [
            {
              name: translate('cmd_print_collateral'),
              printConfig: {
                type: LKPrintButtonConstants.types.loanCollateral,
                page: 'printloancolagree',
                ID: this.props.ID,
                hash: this.props.hash,
                extraID: data.ID,
                extraHash: data.HashSum_CollateralID_,
                chooseFormat: true,
              },
              icon: 'print',
              disabled: data.TypeID === 6 || data.TypeID === 8,
            },
          ]
        : []),
      ...(this.props.permissions.PRINT_COLL_AGREEMENT &&
      (this.props.permissions.COLL_PRINT_WITHOUT_VISA || data.Visa !== 0)
        ? [
            {
              name: translate('cmd_print_collateral_details'),
              printConfig: {
                type: LKPrintButtonConstants.types.loanCollateral,
                page: 'printloancoldetagree',
                ID: this.props.ID,
                hash: this.props.hash,
                extraID: data.ID,
                extraHash: data.HashSum_CollateralID_,
              },
              icon: 'print',
              disabled: data.TypeID === 2 || data.TypeID === 3 || data.TypeID === 4 || data.TypeID === 7,
            },
          ]
        : []),
    ]

    if (this.props.data.base.IsArrested !== 1 && this.state.canDetachCollateral) {
      items.push({
        name: translate('cmd_detach'),
        icon: 'detach',
        action: () => {
          const { ID, hash } = this.props
          this.props.openUnlinkModal(ID, hash, data.ID, data.HashSum_CollateralID_)
        },
      })
    }

    return items
  }

  showContextMenu = (params) => {
    const cell = params.api.context.beanWrappers.beans.beanInstance.rowRenderer.rowCtrlsByRowIndex[
      params.node.rowIndex
    ].getCellCtrl(params.column)

    const contextMenuEvent = new MouseEvent('contextmenu', {
      view: window,
      bubbles: true,
      cancelable: true,
      clientX: this.menuX,
      clientY: this.menuY,
    })

    cell.beans.contextMenuFactory.showMenu(params.node, params.column, params.value, contextMenuEvent)
  }

  checkAttachEditPermissions = async () => {
    const state: {
      canEditCollateral: boolean
      canDetachCollateral: boolean
    } = {
      canEditCollateral: this.state.canAttachCollateral,
      canDetachCollateral: this.state.canDetachCollateral,
    }
    const {
      data: { base },
    } = this.props

    let product: { CFG_ActLoanColEdit: number; CFG_ActLoanColDetach: number; CFG_ClosedLoanColDetach: number }

    if (this.props.permissions.EDIT_COLLATERAL) {
      if (base.StateID === 1) {
        product = await this.props.loadProductDetailsIfNeeded({
          productId: base.ProductID,
          productHash: base.HashSum_ProductID_,
        })

        if (product.CFG_ActLoanColEdit === 1) {
          state.canEditCollateral = true
        }
      } else {
        state.canEditCollateral = true
      }
    }

    if (this.props.permissions.LOAN_DETACH_COLL) {
      if ([1, 2].indexOf(base.StateID) !== -1) {
        if (!product) {
          product = await this.props.loadProductDetailsIfNeeded({
            productId: base.ProductID,
            productHash: base.HashSum_ProductID_,
          })
        }

        if (
          !(
            (base.StateID === 1 && product.CFG_ActLoanColDetach === 0) ||
            (base.StateID === 2 && product.CFG_ClosedLoanColDetach === 0)
          )
        ) {
          state.canDetachCollateral = true
        }
      } else {
        state.canDetachCollateral = true
      }
    }

    this.setState(state)
  }

  handleSearchOptionChange = (_: SyntheticEvent, { value }: { value: string }) => {
    this.setState({ searchOption: value })
  }

  handleInputChange = (_: React.ChangeEvent<HTMLInputElement>, field: { value: string }) => {
    const { collaterals } = this.props.data

    if (field.value) {
      try {
        const filtered = collaterals.filter((row) =>
          row[this.state.searchOption].match(new RegExp(`${field.value}`, 'gi')),
        )

        this.setState({ filtered })
      } catch (error) {
        this.setState({ filtered: null })
      }

      return
    }

    this.setState({ filtered: null })
  }

  handleOpenCollateralSearchModal = () => {
    const { ID, hash } = this.props
    this.props.openBindCollateralModal(ID, hash)
  }

  handleReloadGrid = () => {
    const { ID, hash } = this.props
    this.props.reloadCollaterals(ID, hash)
  }

  handleCollateralAddSuccess = async (collateralID: number, collateralHash: string) => {
    try {
      const { ID, hash } = this.props

      // await Loan.linkCollateral(ID, hash, collateralID, collateralHash)

      //UPDATED API REQUEST loan_oper_api page:linkcollateral
      const result = await this.props.linkCollateral({
        LoanID: ID,
        HashSum_LoanID_: hash,
        CollateralID: collateralID.toString(),
        HashSum_CollateralID_: collateralHash,
      })

      if (!linkCollateral.fulfilled.match(result)) {
        throw { Error: { Text: result.payload } }
      }

      this.handleReloadGrid()

      if (this.props.Print_After_Coll_Add === '1') {
        setTimeout(() => {
          this.props.openCollateralDetails()
        }, 1000)
      }
    } catch (err) {
      if (err?.Error) {
        const message = translateLKMessage(err.Error?.Text)
        this.props.openErrorModal(message)
      }
    }
  }

  handleCollateralEditSuccess = async () => {
    this.handleReloadGrid()
  }

  openCollateralAddForm = () => {
    const {
      data: { base },
    } = this.props

    this.props.openCollateralAddForm(base.ClientID, base.HashSum_ClientID_)
  }

  render() {
    const {
      type,
      ID,
      hash,
      data: { base, collaterals },
      AuthenticatedUserID,
      permissions,
    } = this.props

    const collateralsArray = this.state.filtered || collaterals

    return (
      <div className="u-flex u-directionColumn u-fluid">
        <div className="u-flex u-directionColumn u-fluid">
          <div className="u-fluid u-flex">
            <CollateralForm name={COLLATERAL_ADD} onSuccess={this.handleCollateralAddSuccess} />

            <CollateralForm name={COLLATERAL_EDIT} onSuccess={this.handleCollateralEditSuccess} />

            {/*@ts-ignore */}
            <BindCollateralModal
              fullname={base.FullName}
              onFinish={this.handleReloadGrid}
              bindedCollaterals={collaterals}
            />
            <UnlinkCollateralModal onFinish={this.handleReloadGrid} />

            <LKPrintGridContainer>
              <LKPrintGrid
                instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${base.ID}-Collaterals`}
                rowData={collateralsArray}
                onRowDoubleClicked={this.onRowDoubleClicked}
                getContextMenuItems={this.getContextMenuItems}
                {...LKGridConfig}
              />
            </LKPrintGridContainer>

            <div style={{ flex: 1, padding: 5, borderBottom: '1px solid lightgray' }}>
              <Dropdown
                size="mini"
                search
                options={this.state.searchOptions}
                defaultValue={this.state.searchOption}
                onChange={this.handleSearchOptionChange}
                fluid
                selection
                style={{ marginBottom: 10 }}
              />

              <div className="u-flex">
                <Input onChange={this.handleInputChange} style={{ flex: 1 }} />
                <LKBaseButton alias="filter" />
              </div>

              {permissions.PRINT_LOAN_AGREEMENT && (
                <div style={{ marginTop: 20 }}>
                  {(permissions.LOAN_PRINT_WITHOUT_VISA || base.VisaDate !== null) && (
                    <LKPrintButton
                      type={LKPrintButtonConstants.types.loan}
                      name={translate('cmd_print_creditagreement')}
                      ID={ID}
                      hash={hash}
                      page="printloanagreement"
                      leftward
                      chooseFormat
                    />
                  )}
                  <div style={{ height: 10 }} />

                  {base.ProductType === 5 && (
                    <LKPrintButton
                      type={LKPrintButtonConstants.types.loan}
                      upward
                      name={translate('cmd_print_bic')}
                      ID={ID}
                      hash={hash}
                      page="printloanbic"
                      leftward
                    />
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="u-flex u-spaceBetween u-padding-5">
            <div>
              {base.IsArrested !== 1 && this.state.canAttachCollateral && (
                <LKButton size="tiny" alias="add" onClick={this.openCollateralAddForm} permission="ADD_COLLATERAL">
                  {translate('cmd_add_collateral')}
                </LKButton>
              )}

              <div className="u-marginTop-5">
                {base.IsArrested !== 1 && this.state.canAttachCollateral && (
                  <LKButton size="tiny" alias="attach" onClick={this.handleOpenCollateralSearchModal}>
                    {translate('cmd_attach')}
                  </LKButton>
                )}
              </div>
            </div>

            <div>
              <DataSegment style={{ textAlign: 'center' }}>{translate('pan_collateral_price_t')}</DataSegment>

              <DataSegment style={{ marginTop: 5, textAlign: 'center', height: 33 }}>
                {renderPriceRate(base.CollateralPrice, base.OSBalance)}
              </DataSegment>
            </div>
          </div>

          <hr style={{ margin: 0 }} />

          <div className="u-flex u-padding-5">
            <div>
              {this.props.permissions.LOAN_VISA && (
                <VisaLoanButton
                  disabled={!!base.VisaDate}
                  type={type}
                  ID={ID}
                  hash={hash}
                  clientID={base.ClientID}
                  clientHash={base.HashSum_ClientID_}
                />
              )}
              <BlockLoanButton disabled={base.IsArrested === 1} type={type} ID={ID} hash={hash} />
            </div>

            <div className="u-flexCenter u-fluid">
              <div>
                <p style={{ color: '#008000', textAlign: 'center' }}>
                  {translate('lbl_visa_t')} {base.XVisaBy} {LKDate.from(base.VisaDate).toTString()}
                </p>

                <p
                  style={{
                    textAlign: 'center',
                    color: base.IsArrested ? '#FF0000' : '#008000',
                  }}
                >
                  {translate('lbl_arrested_t')} {base.XArrestBy} {LKDate.from(base.ArrestDate).toString()}
                </p>
              </div>
            </div>

            <div>
              {this.props.permissions.LOAN_VISA && (
                <UndoVisaLoanButton
                  disabled={!base.VisaDate || base.VisaUserID !== AuthenticatedUserID}
                  type={type}
                  ID={ID}
                  hash={hash}
                />
              )}

              <UndoLoanBlockButton disabled={base.IsArrested === 0} type={type} ID={ID} hash={hash} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Collaterals
